import React from "react";
import { QRCodeSVG } from "qrcode.react";

const GroupInviteQRCode = ({ inviteLink }) => {
  if (!inviteLink) {
    return null; // Ne rien afficher si aucun lien n'est fourni
  }

  return (
    <div className="mt-4 text-center items-center flex flex-col">
      <h2 className="text-lg font-bold bg-gray-200 dark:bg-gray-800 p-2 mb-4 w-full">QR Code à scanner par vos judokas</h2>
      <QRCodeSVG value={inviteLink} size={256} />
      <p className="mt-2 text-gray-700">
        Partagez ce QR code avec vos adhérents pour rejoindre le groupe.
      </p>
    </div>
  );
};

export default GroupInviteQRCode;
